var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-wapper"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright  "),_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v("  "+_vm._s(_vm.date)+" 苏州市朝旭科技有限公司 版权所有")]),_vm._v(" "),_c('a',{staticClass:"copyright",attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("网站备案号：苏ICP备19003956号-5")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af0837a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/CopyrightFooter.vue
// module id = null
// module chunks = 